<script>
	import {ignore} from "../../Common/tools";
	import {External, M} from "../../external"

	export let onSelect = ignore;

</script>

<h3 class="roboto col20 f-left t-center mt-35">{M.SELECT_CAMPAIGN_FLOW}</h3>
<div class="col20 flex f-left t-center justify-center" style="padding: 20px 35px 35px; box-sizing: border-box;">
	<a class="addon-select half-select" style="max-width: 300px;" on:click={() => onSelect("email")}>

		<img src={External.staticResource("/images/email-campaign.png")} alt=""/>

		<h4 class="col20 f-left mt-25">{M.EMAIL_CAMPAIGN}</h4>
		<span class="col20 f-left t-center light-gray-text">{M.EMAIL_CAMPAIGN_DESC}</span>
	</a>
	<a class="addon-select half-select" style="max-width: 300px;" on:click={() => onSelect("sms_whatsapp")}>

		<img src={External.staticResource("/images/sms-campaign.png")} alt=""/>

		<h4 class="col20 f-left mt-25">{M.SMS_WHATSAPP_CAMPAIGN}</h4>
		<span class="col20 f-left t-center light-gray-text">{M.SMS_WHATSAPP_CAMPAIGN_DESC}</span>
	</a>
</div>
